document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', function (e) {
    const currentEl = e.target.closest('.stockist-list-result')
    if (!currentEl) return
    currentEl.classList.toggle('expanded')

    const listEls = document.querySelectorAll('.stockist-list-result')

    listEls.forEach((item) => {
      if (item === currentEl) return
      item.classList.remove('expanded')
    })
  })

  const targetNode = document.querySelector('#main-stockist-widget')

  const config = { attributes: false, childList: true, subtree: true }
  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {

      if (mutation.target.matches('form.stockist-search-form')) {
        const formAddedNodes = Object.values(mutation.addedNodes)
        const isEntryFormAdded = formAddedNodes.some(node => node.classList.contains('stockist-query-entry'))
        if (!isEntryFormAdded) return
        // Stockist shadow Root Modify
        mutation.target.querySelector('.stockist-search-field').setAttribute('placeholder', '')
      }
      
      if (mutation.type === 'childList' && mutation.target.matches('div.stockist-result-list')) {
        const listNode = document.querySelector('.stockist-result-list')
        const searchFieldValue = document.querySelector('.stockist-search-field').value
        const headerOffset =
          getComputedStyle(document.documentElement).getPropertyValue(
            '--header-height'
          ) || 56

        if (searchFieldValue === '') return

        window.scrollTo({
          top:
            listNode.getBoundingClientRect().top +
            window.pageYOffset -
            parseInt(headerOffset, 10),
          behavior: 'smooth',
        })

        const addedNodesArr = Object.values(mutation.addedNodes)
        const isStockListShown = addedNodesArr.some(node => node.tagName === 'UL')

        if (isStockListShown) {
          const newNode = document.createElement("h3");
          const searchResultsLabel = document.getElementById('js-results-label');
          const textNode = document.createTextNode(searchResultsLabel.innerText + searchFieldValue);
          newNode.classList.add('stockist-result-list__title')
          newNode.appendChild(textNode);
          
          const parentDiv = document.querySelector('.stockist-result-list')
          const listWrapper = addedNodesArr[0]
          parentDiv.insertBefore(newNode, listWrapper);
        }
      }
    }
  }

  const observer = new MutationObserver(callback)
  observer.observe(targetNode, config)

  // No result email copy to clipboard

  const enterEvent = ['mouseover', 'focusin']
  const exitEvent = ['mouseout', 'focusout']

  enterEvent.forEach(event => {
    document.addEventListener(event, (e) => {
      if(!e.target.matches('.main-stockist__error-message-subtitle > a[href^="mailto:"')) return
      const targetEl = document.querySelector('.main-stockist__error-message-subtitle > a[href^="mailto:"')
      targetEl.classList.add('show')

      if(targetEl.hasAttribute('data-copy-init')) return
      targetEl.setAttribute('data-email', targetEl.innerHTML)

      targetEl.innerHTML += (`
        <span class="stockist-widget__copy-tooltip" role="tooltip">Click to Copy</span>
      `)

      targetEl.setAttribute('data-copy-init', '')
    })
  })

  exitEvent.forEach(event => {
    document.addEventListener(event, (e) => {
      if(!e.target.matches('.main-stockist__error-message-subtitle > a[href^="mailto:"')) return
      const targetEl = document.querySelector('.main-stockist__error-message-subtitle > a[href^="mailto:"')
      targetEl.classList.remove('show')
      setTimeout(() => {
        const successEl = e.target.querySelector('span')
        successEl.innerHTML = 'Click to Copy'
      }, 750)
    })
  })

  document.addEventListener('click', (e) => {
    if(!e.target.matches('.main-stockist__error-message-subtitle > a[href^="mailto:"')) return
    e.preventDefault()
    const email = e.target.dataset.email

    navigator.clipboard.writeText(email).then(() => {
      const successEl = e.target.querySelector('span')
      successEl.innerHTML = 'Copied'
    })
  })
})
